import config from '../nyConfig'
const ApiStore = {
    "商城用户列表": new config({ url: '/manager/listStoreUser', showSuccessMessage: false, useToken: true }),
    "导出商城用户": new config({ url: '/manager/exportStoreUser', showSuccessMessage: false, useToken: true }),
}

export default ApiStore